import { useEffect, useState } from 'react';

// Build-time HTML must not freeze a date or mismatch hydration on later days.
export const useTodayDate = () => {
  const [today, setToday] = useState('');
  useEffect(() => { setToday(new Date().toISOString().split('T')[0]); }, []);
  return today;
};